(function () {
  'use strict';
  var config = window.UABrandSearchConfig;
  if (!config) return;
  function normalize(value) {
    return String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[^\p{L}\p{N}]/gu, '').trim();
  }
  var vendors = new Map();
  config.vendors.forEach(function (vendor) { vendors.set(normalize(vendor), vendor); });
  function matchName(query) {
    var clean = String(query || '').replace(/\btag:\s*(women|men)\b/gi, '').trim();
    var key = normalize(clean);
    if (vendors.has(key)) return vendors.get(key);
    // Unique suffixes are derived from the catalog: Louboutin → Christian Louboutin.
    // Never guess between two designers sharing the same name fragment.
    if (key.length < 4 || /[:"()]/.test(clean)) return null;
    var candidates = config.vendors.filter(function(v) {
      var words = v.split(/\s+/);
      return words.some(function(_, i) {
        return normalize(words.slice(i).join(' ')) === key;
      });
    });
    if (candidates.length === 1) return candidates[0];
    candidates = config.vendors.filter(function(v) { return normalize(v).startsWith(key); });
    if (candidates.length === 1) return candidates[0];
    return null;
  }

  function parse(query) {
    var clean = String(query || '').replace(/\btag:\s*(women|men)\b/gi, '').trim();
    if (/\bvendor\s*:/i.test(clean)) return null;
    var exact = matchName(clean);
    if (exact) return { vendor: exact, terms: '' };
    var names = config.vendors.slice().sort(function(a,b) { return b.length-a.length; });
    for (var name of names) {
      var pattern = Array.from(name.replace(/\s/g, '')).map(function(c) {
        return c.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      }).join('\\s*');
      var found = new RegExp('(^|[^\\p{L}\\p{N}])(' + pattern + ')(?=$|[^\\p{L}\\p{N}])', 'iu').exec(clean);
      if (!found) continue;
      var start = found.index + found[1].length;
      return { vendor: name, terms: (clean.slice(0,start) + ' ' + clean.slice(start+found[2].length)).trim().replace(/\s+/g,' ') };
    }
    // Resolve catalog-derived aliases anywhere in a product query.
    var parts = clean.split(/\s+/);
    for (var length = parts.length - 1; length > 0; length--) {
      for (var offset = 0; offset + length <= parts.length; offset++) {
        var alias = parts.slice(offset, offset + length).join(' ');
        var partial = matchName(alias);
        if (partial) return {vendor: partial, terms: parts.slice(0, offset).concat(parts.slice(offset + length)).join(' ')};
      }
    }
    return null;
  }
  function match(query) { var parsed = parse(query); return parsed ? parsed.vendor : null; }
  function gender(form, query) {
    var field = form && form.querySelector('[name="gender"]');
    if (field && /^(men|women)$/.test(field.value)) return field.value;
    var tag = String(query || '').match(/\btag:\s*(women|men)\b/i);
    if (tag) return tag[1].toLowerCase();
    var here = new URL(location.href);
    var g = here.searchParams.get('gender');
    if (/^(men|women)$/.test(g)) return g;
    var path = here.pathname.match(/\/(women|men)(?:[-/]|$)/);
    if (path) return path[1];
    try { g = localStorage.getItem('uaGender'); } catch (_) {}
    return /^(men|women)$/.test(g) ? g : 'women';
  }
  function url(query, selectedGender, source, suggesting) {
    var parsed = parse(query);
    var clean = String(query || '').replace(/\btag:\s*(women|men)\b/gi, '').trim();
    // Existing internal URLs and filter forms must retain their complete query.
    if (/\b(?:vendor|title|product_type|variants\.sku)\s*:/.test(clean)) return null;
    var vendor = parsed && parsed.vendor;
    parsed = parsed || {terms: clean};
    var target = new URL(config.searchUrl, location.origin);
    // Keep Shopify theme-preview and market context across the navigation.
    var here = new URL(source || location.href);
    ['preview_theme_id', '_fd', 'pb', 'locale', 'country'].forEach(function (key) {
      if (here.searchParams.has(key)) target.searchParams.set(key, here.searchParams.get(key));
    });
    function quote(value) { return '"' + value.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"'; }
    var scoped = vendor ? 'vendor:' + quote(vendor) + ' AND tag:' + selectedGender : 'tag:' + selectedGender;
    if (parsed.terms) {
      var terms = parsed.terms.split(/\s+/);
      var words = terms.map(function(word, index) {
        var partial = suggesting && index === terms.length - 1;
        if (/^sneakers?$/i.test(word)) return '(title:sneaker* OR product_type:"Sneakers" OR product_type:"Sneaker")';
        var clauses = ['title:', 'product_type:', 'variants.title:', 'variants.sku:'].map(function(field) {
          return field + (partial && /^[\p{L}\p{N}]+$/u.test(word) ? word + '*' : quote(word));
        });
        if (!vendor) clauses.push('vendor:' + (partial && /^[\p{L}\p{N}]+$/u.test(word) ? word + '*' : quote(word)));
        // Complete even a ONE-letter type prefix, without replacing title matches.
        if (partial) (config.types || []).forEach(function(type) {
          if (type.toLocaleLowerCase().split(/[^\p{L}\p{N}]+/u).some(function(token) {
            return token.startsWith(word.toLocaleLowerCase());
          })) clauses.push('product_type:' + quote(type));
        });
        return '(' + Array.from(new Set(clauses)).join(' OR ') + ')';
      });
      scoped += ' AND (' + words.join(' AND ') + ')';
    }
    target.searchParams.set('q', scoped);
    target.searchParams.set('ua_query', String(query).replace(/\btag:\s*(women|men)\b/gi, '').trim());
    target.searchParams.set('type', 'product');
    if (vendor) target.searchParams.set('view', 'designers');
    target.searchParams.set('gender', selectedGender);
    target.searchParams.set('options[prefix]', 'none');
    return target.href;
  }
  window.UABrandSearch = {
    match: match, parse: parse, url: url,
    suggestionsUrl: function(query, selectedGender) {
      return url(query, selectedGender, undefined, true);
    }
  };
  // Registered in the head, before the theme's other capturing submit handlers.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.action || !/\/search\/?$/.test(new URL(form.action, location.href).pathname)) return;
    if (form.matches('.ua-sort-form, .ua-filter-form')) return;
    var input = form.querySelector('[name="q"]');
    if (!input) return;
    var target = url(input.value, gender(form, input.value));
    if (!target) return; // Preserve existing structured search URLs.
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(target);
  }, true);
  document.addEventListener('click', function (event) {
    var a = event.target.closest && event.target.closest('a[data-view-all], a.btn-view-all-luxe');
    if (!a) return;
    var old = new URL(a.href, location.href);
    var query = old.searchParams.get('q');
    var target = url(query, gender(a.closest('form'), query));
    if (!target) return;
    // Rewriting href also preserves browser modifier-key/open-in-new-tab behavior.
    a.href = target;
    event.stopImmediatePropagation();
  }, true);
  // Recover bookmarked bare-brand search URLs as well as form submissions.
  var current = new URL(location.href);
  if (/\/search\/?$/.test(current.pathname)) {
    var query = current.searchParams.get('q');
    var target = url(query, gender(null, query));
    if (target && query && new URL(target).searchParams.get('q') !== query) {
      var recovered = new URL(target);
      // Restart obsolete broad pagination, but retain selected filters and sorting.
      current.searchParams.forEach(function(value, key) {
        if (key === 'sort_by' || key.startsWith('filter.')) recovered.searchParams.append(key, value);
      });
      location.replace(recovered.href);
    }
  }
  function restoreQuery() {
    var original = current.searchParams.get('ua_query');
    if (!original) return;
    var input = document.getElementById('SearchInput');
    if (input) input.value = original;
    var empty = document.querySelector('#SearchRoot .no-results');
    if (empty && current.searchParams.get('q')) empty.textContent = 'No results found for “' + original + '”.';
    document.querySelectorAll('.ua-filter-form, .ua-sort-form').forEach(function(form) {
      if (form.querySelector('[name="ua_query"]')) return;
      var field = document.createElement('input'); field.type = 'hidden'; field.name = 'ua_query'; field.value = original; form.appendChild(field);
    });
    document.querySelectorAll('.ua-pagination a, a.ua-clear').forEach(function(link) {
      var target = new URL(link.href, location.href); target.searchParams.set('ua_query', original); link.href = target.href;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restoreQuery); else restoreQuery();
})();
